import {CommonModule} from '@angular/common';
import {Component, inject, Input, OnInit} from '@angular/core';
import {Router, RouterModule} from '@angular/router';
import {DxFormModule} from 'devextreme-angular/ui/form';
import {DxLoadIndicatorModule} from 'devextreme-angular/ui/load-indicator';
import notify from 'devextreme/ui/notify';
import {AuthService, AuthClient, MeDto} from 'src/app/services';
import {of} from "rxjs";
import {switchMap, take} from "rxjs/operators";

const notificationText = 'We\'ve sent a link to reset your password. Check your inbox.';

@Component({
    selector: 'reset-password-form',
    templateUrl: './reset-password-form.component.html',
    styleUrls: ['./reset-password-form.component.scss'],
    imports: [
        CommonModule,
        RouterModule,
        DxFormModule,
        DxLoadIndicatorModule,
    ]
})
export class ResetPasswordFormComponent implements OnInit {
    @Input() signInLink = '/auth/sign-in';
    @Input() buttonLink = '/auth/sign-in';

    private authService = inject(AuthService);
    private router = inject(Router);
    private auth = inject(AuthClient);

    defaultAuthData: MeDto;

    loading = false;

    formData: any = {};

    async onSubmit(e: Event) {
        e.preventDefault();
        const {email} = this.formData;
        this.loading = true;

        this.authService.resetPassword(email).subscribe(
            {
                next: async () => {
                    this.loading = false;
                    await this.router.navigate([this.buttonLink]);
                    notify(notificationText, 'success', 2500);
                },
                error: (errors: Array<any>) => {
                    this.loading = false;
                    let errMsg = errors.pop();
                    notify({message: errMsg.message, position: 'bottom center'}, 'error', 3000);
                }
            }
        );
    }

    async ngOnInit(): Promise<void> {
        this.authService.isAuthenticated$().pipe(
            take(1),
            switchMap(isAuth => {
                if (isAuth)
                    return this.auth.me()
                else
                    return of(null);
            })
        ).subscribe(async (me: MeDto) => {
            this.defaultAuthData = me;
        });
    }
}
